/* 🤖 this file was generated by svg-to-ts */
export const matIconCompareArrows: {
  name: 'compare-arrows';
  data: string;
} = {
  name: 'compare-arrows',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"/></svg>`
};
